

















































import { Vue, Component } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import { ifRegister, register, userInfo, del1 } from '../api';
import { Dialog, Toast } from 'vant';

Vue.use(Dialog).use(Toast);
@Component
export default class Join extends Vue {
  show = false;
  phone: string = '';
  unionId: string | null = '';
  noData: boolean = false;
  data: any = [];
  async created() {
    if (isWeiXin()) {
      this.WechatLogin();
      this.unionId = window.localStorage.getItem('unionid');
      const data = {
        unionid: this.unionId,
      };
      const res: any = await ifRegister(data);
      if (res.code === 200) {
        this.show = true;
      } else if (res.msg === '已绑定手机号') {
        const res: any = await userInfo(data);
        this.data = res.data;
      }
    } else if (window.udid) {
      const data = {
        udid: window.udid,
        appkey: window.appkey,
        token: window.gettoken(),
      };
      const userLogin = window.gettoken() && window.gettoken() !== 'null';
      if (window.udid && !userLogin) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
        return false;
      } else {
        const res: any = await ifRegister(data);
        if (res.code === 200) {
          this.show = true;
          this.noData = true;
        } else if (res.msg === '已绑定手机号') {
          const res: any = await userInfo(data);
          this.data = res.data;
        }
      }
    }
  }
  WechatLogin() {
    const unionid = window.localStorage.getItem('unionid');
    if (!unionid) {
      if (isWeiXin() || !window.udid) {
        const appId = 'wx1949ed4a473b87ed';
        location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
          location.href,
        )}`;
      }
    }
  }
  close() {
    if (!this.phone) {
      this.$router.go(0);
      return false;
    } else if (!/^1[345789][0-9]{9}$/.test(this.phone)) {
      Toast('请输入正确的手机号码');
      setTimeout(() => {
        this.show = true;
      }, 2000);
      return false;
    } else {
      Dialog.confirm({
        title: '您绑定的手机号为',
        message: `${this.phone}请确认！`,
      })
        .then(async () => {
          // on confirm
          const data = {
            unionid: this.unionId,
            udid: window.udid,
            appkey: window.appkey,
            token: window.gettoken(),
            phone: this.phone,
            wxnickname: window.localStorage.getItem('nickname'),
            wxheadimg: window.localStorage.getItem('headimgurl'),
          };
          const res: any = await register(data);
          Toast(`${res.msg}`);
        })
        .catch(() => {
          // on cancel
          this.show = true;
        });
    }
  }
  goDetail(enable: string, id: string) {
    if (enable === '0') {
      enable = '2';
    }
    this.$router.push(`worksDetail?id=${id}&enable=${enable}`);
  }
  del(e: Event) {
    // console.log(111, e.currentTarget.id);
    const id = (e.currentTarget as HTMLElement).id;
    e.stopPropagation();
    Dialog.confirm({
      title: '删除后作品数据、点赞数据都将清空',
      message: '确定删除吗？',
    })
      .then(async () => {
        const data = {
          unionid: this.unionId,
          udid: window.udid,
          appkey: window.appkey,
          token: window.gettoken(),
          id,
        };
        const res: any = await del1(data);
        if (res.code === 200) {
          Toast(`${res.msg}`);
          setTimeout(() => {
            this.$router.go(0);
          }, 1500);
        } else {
          Toast(`${res.msg}`);
        }
      })
      .catch(() => {
        // on cancel
      });
  }
  async goSave() {
    if (!isWeiXin() && !window.udid) {
      Toast('请使用APP、微信打开活动页面完成登录、授权。');
      return;
    }
    if (isWeiXin()) {
      this.WechatLogin();
      this.unionId = window.localStorage.getItem('unionid');
      const data = {
        unionid: this.unionId,
      };
      const res: any = await ifRegister(data);
      if (res.code === 200) {
        this.show = true;
      } else if (res.msg === '已绑定手机号') {
        const res: any = await userInfo(data);
        this.data = res.data;
      }
    } else if (window.udid) {
      const data = {
        udid: window.udid,
        appkey: window.appkey,
        token: window.gettoken(),
      };
      const userLogin = window.gettoken() && window.gettoken() !== 'null';
      if (window.udid && !userLogin) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
        return false;
      } else {
        const res: any = await ifRegister(data);
        if (res.code === 200) {
          this.show = true;
          this.noData = true;
        } else if (res.msg === '已绑定手机号') {
          const res: any = await userInfo(data);
          this.data = res.data;
        }
      }
    }
    if (this.data.length < 6) {
      this.$router.push('save');
    } else {
      Toast('您已经投满6次，请在“秀厨艺”中查看自己已上传作品。');
    }
  }
}
